const CLASSNAME_HIDDEN_TEASER = '.org--large-teaser.hidden';
const CLASSNAME_MORE_BUTTON = '.more-button';
class ShowTeaser {
  constructor(options = {}) {
    this.element = options.element;
  }

  init() {
    const buttons = document.querySelectorAll(CLASSNAME_MORE_BUTTON);
    if (buttons.length > 0) {
      buttons[buttons.length - 1].classList.add('hidden');
    }

    this.element.addEventListener('click', () => {
      const hiddenTeaser = document.querySelectorAll(CLASSNAME_HIDDEN_TEASER);
      this.element.classList.add('hidden');
      if (hiddenTeaser.length > 0) {
        hiddenTeaser[0].classList.remove('hidden');
      }
    });
  }
}

export default ShowTeaser;
